import { createReducer, on } from '@ngrx/store';
import ScreenInterimActions from '../../actions/generations/screen-interim.actions';
import { GenerationActions } from '../../actions/generations/generation.actions';

export interface ScreensInterimState {
  data: any;
  appNavStructure: any;
  selectedScreens: any;
  screenStructureInterim: any;
  results: any;
  error: any;
  deletedScreenInterimId: any;
}

export const initialState: ScreensInterimState = {
  data: {},
  appNavStructure: {},
  selectedScreens: null,
  screenStructureInterim: null,
  results: null,
  error: null,
  deletedScreenInterimId: null
};

export const ScreenInterimReducer = createReducer(
  initialState,
  on(ScreenInterimActions.getScreensInterim, (state, { getScreensInterimApiConstants }) => {
    return {
      ...state,
      getScreensInterimApiConstants
    };
  }),
  on(ScreenInterimActions.setScreensInterim, (state, { screensInterim }) => {
    return {
      ...state,
      selectedScreens: screensInterim
    };
  }),
  on(ScreenInterimActions.getScreenStructureInterim, (state, { getScreenStructureInterimApiConstants }) => {
    return {
      ...state,
      getScreenStructureInterimApiConstants
    };
  }),
  on(ScreenInterimActions.setScreenStructureInterim, (state, { screenStructureInterim }) => {
    return {
      ...state,
      screenStructureInterim
    };
  }),
  on(ScreenInterimActions.updateScreenStructureInterim, (state, { updateStructureInterimApiConstants, updatedStructure }) => {
    return {
      ...state,
      ...{ updateStructureInterimApiConstants },
      ...{ updatedStructure }
    };
  }),
  on(ScreenInterimActions.updateScnAndDMConfigInterim, (state, { updateApiCons, updatedData }) => {
    return {
      ...state,
      ...{ updateApiCons },
      ...{ updatedData }
    };
  }),
  on(ScreenInterimActions.saveConfFlCntSuccessInterim, (state, { results }) => {
    return {
      ...state,
      results
    };
  }),
  on(ScreenInterimActions.saveConfFlCntFailureInterim, (state, { error }) => {
    return {
      ...state,
      error
    };
  }),
  on(ScreenInterimActions.deleteScreenInterim, (state, { deleteScreenInterimApi, screenId }) => {
    return {
      ...state,
      ...{ deleteScreenInterimApi },
      ...{ screenId }
    };
  }),
  on(ScreenInterimActions.currentDeleteScreenInterim, (state, { deletedScreenInterimId }) => {
    return {
      ...state,
      ...{ deletedScreenInterimId }
    };
  }),
  on(ScreenInterimActions.clearScreensInterim, (state) => {
    return {
      ...state,
      selectedScreens: null
    };
  }),
  // Reset screen interim state when generation wizard is closed
  on(GenerationActions.resetGeneration, () => initialState)
);